import React from 'react';
import { Shield, Brain, Lock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

export const FeaturesTab = ({ settings, handleChange }) => (
  <Card className="bg-white border-slate-200">
    <CardHeader>
      <CardTitle className="text-slate-900 flex items-center gap-2">
        <Shield className="w-5 h-5 text-indigo-700" />
        Funcionalidades Globais
      </CardTitle>
      <CardDescription className="text-slate-500">
        Ativar/desativar funcionalidades para toda a plataforma
      </CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      {/* AI Triage */}
      <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-500/20 rounded-lg">
            <Brain className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <Label className="text-slate-900">Triagem com IA</Label>
            <p className="text-sm text-slate-500 mt-1">
              Análise automática de denúncias com inteligência artificial
            </p>
          </div>
        </div>
        <Switch
          checked={settings.enable_ai_triage}
          onCheckedChange={(checked) => handleChange('enable_ai_triage', checked)}
          data-testid="ai-triage-toggle"
        />
      </div>

      {/* MFA */}
      <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-green-500/20 rounded-lg">
            <Lock className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <Label className="text-slate-900">Autenticação Multi-Fator (MFA)</Label>
            <p className="text-sm text-slate-500 mt-1">
              Permitir configuração de MFA para utilizadores
            </p>
          </div>
        </div>
        <Switch
          checked={settings.enable_mfa}
          onCheckedChange={(checked) => handleChange('enable_mfa', checked)}
          data-testid="mfa-toggle"
        />
      </div>
    </CardContent>
  </Card>
);
